import { type BuildDetailsFieldsParams, field, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildContractualModificationsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const contractAdditionalQuestions = opportunity?.contract_additional_questions;
  const contract = opportunity?.contract;

  return [
    withLayout(field('Educational Package Status', contractAdditionalQuestions?.educational_package_status__c), {
      columns: 2,
    }),
    withLayout(
      field(
        'Educational Package Wording',
        contractAdditionalQuestions?.educational_packages_wording__c,
        undefined,
        true,
      ),
      { columns: 2 },
    ),
    withLayout(
      field('Contract Terms Modification', contract?.partner_b_contract_terms_modification__c, undefined, true),
      { columns: 2 },
    ),
    withLayout(field('Payment Terms Modification', contract?.payment_terms_modification__c, undefined, true), {
      columns: 2,
    }),
  ];
}
